//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { MENU_DESC } from './menu-desc';
import metadataTour from '@/views/metadata/components/tour';
export default {
  name: 'ObjectList',
  components: { metadataTour },
  data() {
    return {
      MENU_DESC,
      list: [],
      object_id: '',
      object_name: '',
      nextStep: -1,
      stepOver: false,
      layout_type: '',
    };
  },
  computed: {
    ...mapGetters('user', {
      menuList: 'getMenuList',
    }),
    routeList() {
      // const list = [];
      const { routes } = this.$router.options;
      const list = this.getRouteList(routes);
      return list;
    },
  },
  mounted() {
    this.changeMenu();
    this.object_id = this.$route.query.id;
    this.object_name = this.$route.query.name;
    this.layout_type = this.$route.query?.layout_type || '';
    sessionStorage.setItem('object_name', this.object_name);
    this.$watch(
      () => this.$route,
      () => {
        // 路由变化时，获取元数据id和name,以及判断是否显示过新手指引
        this.object_id = this.$route.query.id;
        this.object_name = this.$route.query.name;
        this.layout_type = this.$route.query?.layout_type || '';
      },
    );
  },
  methods: {
    getRouteList(routeList) {
      let names = [];
      routeList.forEach((route) => {
        names.push(route.name);
        if (route.children && route.children.length) {
          names = names.concat(this.getRouteList(route.children));
        }
      });
      return names;
    },
    changeMenu(codeList = []) {
      const children =
        this.menuList
          .find((menu) => {
            return menu.code === 'power';
          })
          ?.children?.find((submenu) => {
            return submenu.code === 'old-metadata';
          })?.children || [];
      if (!codeList.length) {
        this.list = children;
      } else {
        this.list = children.filter(({ code }) => codeList.includes(code));
      }
      this.list = this.list.filter((item) => {
        return this.condition(item);
      });
    },
    condition(menu) {
      const isReg = this.routeList.includes(menu.path) || this.routeList.includes(menu.code);
      return isReg;
    },
    changeRoute(type) {
      this.layout_type = type || '';
    },
  },
};
